module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0052_design_clean_v002.3bc4a8b6.png";